import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
let pending = null;
const listeners = new Set();

const load = () => {
  if (!pending) {
    pending = axios.get(`${API}/settings/public`)
      .then((r) => r.data)
      .catch(() => ({ inventory_enabled: false }))
      .then((d) => { cache = d; listeners.forEach((l) => l(d)); return d; });
  }
  return pending;
};

export const setSiteSettingsCache = (d) => {
  cache = { ...cache, ...d };
  pending = Promise.resolve(cache);
  listeners.forEach((l) => l(cache));
};

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(cache);
  useEffect(() => {
    listeners.add(setSettings);
    if (!cache) load();
    return () => listeners.delete(setSettings);
  }, []);
  return settings;
};
